import { Box, Typography } from "@material-ui/core";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import { get } from "lodash";
import moment from "moment";
import { KENDO_DATE_FORMAT } from "src/constants";

export const useFeedbackGrid = () => {
  const feedbackListingColumns = [
    {
      title: "Rater",
      field: "rater",
      key: "rater",
      show: true,
      sortable: false
    },
    {
      title: "Comments",
      field: "comments",
      key: "comments",
      show: true,
      sortable: false
    },
    {
      title: "Completed on",
      field: "completedOn",
      key: "completedOn",
      show: true,
      sortable: false
    }
  ];

  const feedbackFetchColumn = column => {
    let columnObject = { ...column };

    switch (column.field) {
      case "rater":
        columnObject = {
          ...column,
          cell: colProps => <td>{get(colProps, "dataItem.rater")}</td>
        };
        break;
      case "comments":
        columnObject = {
          ...column,
          cell: colProps => <td className="pre-wrap">{get(colProps, "dataItem.comments")}</td>
        };
        break;
      case "completedOn":
        columnObject = {
          ...column,
          cell: colProps => <td>{get(colProps, "dataItem.completedOn")}</td>
        };
        break;
      default:
        columnObject = { ...column };
        break;
    }

    return <Column {...columnObject} />;
  };

  const formatSkillRatingPeopleWise = (data, expanded) => {
    return (data || []).map(item => {
      let dateString = item?.date ? moment(item?.date) : moment();
      // dateString = `${moment(dateString).get("year")}/${
      //   moment(dateString).get("month") + 1
      // }/${moment(dateString).get("date")}`;

      const firstName = get(item, "rater.firstName", "");
      const lastName = get(item, "rater.lastName", "");
      const profileImage = get(item, "rater.profileImage.fileName", "");
      const surveyCheckin = get(item, "questionResponse", "");
      const comments = get(item, "comments", []);
      // const response = map(surveyCheckin, "userAnswer").filter(
      //   i => !isEmpty(i)
      // );

      return {
        id: get(item, "rater.id", ""),
        name: `${firstName} ${lastName}`,
        firstName,
        lastName,
        profileImage,
        score: get(item, "score", ""),
        comments,
        dueDate: new Date(dateString),
        expanded: expanded || false,
        // status: STATUS[get(item, "checkInStatus", "")],
        surveyCheckin
        // response: `${size(response)}/${size(surveyCheckin)}`,
        // completedResponse: size(response)
      };
    });
  };

  const fetchRatingByPeopleDetailsColumns = (column, checkInType, data) => {
    let columnObject = { ...column };
    let columnMenu = {
      columnMenu: props => (
        <CustomColumnMenu
          {...props}
          columns={columnObject}
          data={data}
          onColumnsSubmit={() => { }}
        />
      )
    };

    switch (column.field) {
      // case "title":
      //   columnObject = {
      //     ...column,
      //     ...columnMenu,
      //     cell: colProps => {
      //       return (
      //         <td>
      //           <Typography variant="body2" className="multi-wrap-2 font-13">
      //             {`${get(colProps, "dataItem.id")}. ${get(
      //               colProps,
      //               "dataItem.title"
      //             )}`}
      //           </Typography>
      //         </td>
      //       );
      //     }
      //   };
      //   break;
      case "name":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: colProps => {
            return (
              <td>
                <Box display="flex" alignItems="center">
                  <UserProfileWidget
                    firstName={get(colProps, "dataItem.firstName")}
                    lastName={get(colProps, "dataItem.lastName")}
                    url={get(colProps, "dataItem.profileImage")}
                  />
                  <Typography variant="body2" className="font-13">
                    {get(colProps, "dataItem.name")}
                  </Typography>
                </Box>
              </td>
            );
          }
        };
        break;
      case "dueDate":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: colProps => {
            return (
              <td>
                {moment(get(colProps, "dataItem.dueDate", "")).format(
                  KENDO_DATE_FORMAT
                )}
              </td>
            );
          }
        };
        break;
      case "score":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: colProps => {
            return <td>{get(colProps, "dataItem.score", "")}</td>;
          }
        };
        break;
      // case "status":
      //   columnObject = {
      //     ...column,
      //     ...columnMenu,
      //     cell: colProps => {
      //       return <TargetStatus colProps={colProps} />;
      //     }
      //   };
      //   break;
      // case "response":
      //   columnObject = {
      //     ...column,
      //     cell: colProps => {
      //       return checkInType === "SURVEY" ? (
      //         <td>{`${get(colProps, "dataItem.response")}`}</td>
      //       ) : (
      //         <td>
      //           <img
      //             className={`d-block ${
      //               get(colProps, "dataItem.checkInStatus", "") !== "COMPLETE"
      //                 ? classes.disabledIcon
      //                 : "cursor-pointer"
      //             }`}
      //             src={MsgIcon}
      //             alt="icon"
      //             onClick={() => {
      //               get(colProps, "dataItem.checkInStatus", "") ===
      //                 "COMPLETE" &&
      //                 responseModal(get(colProps, "dataItem.id", ""));
      //             }}
      //           />
      //         </td>
      //       );
      //     }
      //   };
      //   break;
      default:
        columnObject = { ...column };
        break;
    }

    return <Column {...columnObject} width={columnObject.minWidth} />;
  };

  return {
    feedbackListingColumns,
    feedbackFetchColumn,
    fetchRatingByPeopleDetailsColumns,
    formatSkillRatingPeopleWise
  };
};
